import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Aos from 'aos'
import 'aos/dist/aos.css'

export default function Contact() {
    useEffect(() => {
        Aos.init({
            duration: 1000
        })

    }, [])
  return<>
  
  {/* Hero Start */}
<div className="container-fluid bg-primary py-5 bg-hero mb-5">
    <div className="container py-5">
        <div className="row justify-content-start">
            <div className="col-lg-8 text-center text-lg-start">
                <h1 className="display-1 text-white mb-md-4">Contact Us</h1>
                <Link to="/" className="btn btn-primary py-md-3 px-md-5 me-3">Home</Link>
                <Link to="" className="btn btn-secondary py-md-3 px-md-5">Contact Us</Link>
            </div>
        </div>
    </div>
</div>
{/* Hero End */}

{/* Contact Start */}
<div className="container-fluid py-5">
            <div className="container">
                <div className="mx-auto text-center mb-5" style={{ maxWidth: "500px" }}>
                    <h6 className="text-primary text-uppercase">Contact Us</h6>
                    <h1 className="display-5">Please Feel Free To Contact Us</h1>
                </div>
                <div className="row g-0">
                    <div className="col-lg-7">
                        <div className="bg-primary h-100 p-5">
                            <form>
                                <div className="row g-3">
                                    <div className="col-6">
                                        <input type="text" className="form-control bg-light border-0 px-4" placeholder="Your Name" style={{ height: "55px" }} data-aos="fade-right" data-aos-delay="200" />
                                    </div>
                                    <div className="col-6">
                                        <input type="email" className="form-control bg-light border-0 px-4" placeholder="Your Email" style={{ height: "55px" }} data-aos="fade-right" data-aos-delay="150"/>
                                    </div>
                                    <div className="col-12">
                                        <input type="text" className="form-control bg-light border-0 px-4" placeholder="Subject" style={{ height: "55px" }} data-aos="fade-right" data-aos-delay="100"/>
                                    </div>
                                    <div className="col-12">
                                        <textarea className="form-control bg-light border-0 px-4 py-3" rows="2" placeholder="Message" data-aos="fade-right" data-aos-delay="90"></textarea>
                                    </div>
                                    <div className="col-12">
                                        <button className="btn btn-secondary w-100 py-3" type="submit">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className=" h-100 p-5">
                            <h2 className="text-dark mb-4">Get In Touch</h2>
                            <div className="d-flex mb-4" data-aos="fade-left" data-aos-delay="280">
                                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: "60px", height: "60px" }}>
                                    <i className="fas fa-map-marker-alt text-dark"></i>
                                </div>
                                <div className="ps-3" >
                                    <h5 className="text-dark">Our Office</h5>
                                    <span className="text-dark">Ademon Fremon Street, Maadi Smouha Building 2, first floor</span>
                                </div>
                            </div>
                            <div className="d-flex mb-4" data-aos="fade-left" data-aos-delay="300">
                                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: "60px", height: "60px" }}>
                                    <i className="fas fa-envelope text-dark"></i>
                                </div>
                                <div className="ps-3" >
                                    <h5 className="text-dark" >Email Us</h5>
                                    <span className="text-dark">Info@elshebany.com</span>
                                </div>
                            </div>
                            <div className="d-flex" data-aos="fade-left" data-aos-delay="350">
                                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: "60px", height: "60px" }}>
                                    <i className="fas fa-phone-alt  fs-4 text-dark"></i>
                                </div>
                                <div className="ps-3">
                                    <h5 className="text-dark">Call Us</h5>
                                    <span className="text-dark">+201553394447</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
<div className="container my-4">
    
<iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d358.68073167021544!2d29.942415710601384!3d31.2106038262343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f5c5509d7519e5%3A0xf3f8e683b36f1aa9!2z2LXZitiv2YTZitin2Kog2K8uINmK2LPYsdinINi52KjYr9in2YTYudi42YrZhQ!5e0!3m2!1sen!2seg!4v1735729731485!5m2!1sen!2seg"
  width="1200"
  height="450"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

</div>
       
        </div>
{/* Contact End */}

  </>
}
